import { render, staticRenderFns } from "./BasketForm.vue?vue&type=template&id=58eabca6&"
import script from "./BasketForm.vue?vue&type=script&lang=js&"
export * from "./BasketForm.vue?vue&type=script&lang=js&"
import style0 from "./BasketForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports